import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/context/LanguageContext";

export function ConsentStep({ value, onChange, errors }) {
  const { t } = useLanguage();
  const c = t.consent;
  return (
    <div className="space-y-6" data-testid="step-consent-content">
      <div>
        <h2 className="text-3xl font-black tracking-tight md:text-4xl">
          {c.title}
        </h2>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          {c.description}
        </p>
      </div>

      <div className="hairline bg-[hsl(var(--warning))]/5 p-5">
        <div className="flex items-start gap-3">
          <Checkbox
            id="consent-ack"
            data-testid="consent-acknowledge-checkbox"
            checked={!!value.acknowledged}
            onCheckedChange={(v) => onChange({ ...value, acknowledged: !!v })}
            className="mt-1"
          />
          <Label
            htmlFor="consent-ack"
            className="cursor-pointer text-sm font-normal leading-relaxed"
          >
            {c.acknowledge}
          </Label>
        </div>
        {errors?.acknowledged && (
          <p className="mt-2 text-xs text-destructive" aria-live="polite">
            {errors.acknowledged}
          </p>
        )}
      </div>

      <div>
        <Label
          htmlFor="signature"
          className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground"
        >
          {c.signature_label}
        </Label>
        <Input
          id="signature"
          data-testid="consent-signature-input"
          value={value.signature || ""}
          onChange={(e) => onChange({ ...value, signature: e.target.value })}
          placeholder={c.signature_placeholder}
          className="mt-2 h-12"
        />
        <p className="mt-1 text-xs text-muted-foreground">
          {c.signature_help}
        </p>
        {errors?.signature && (
          <p className="mt-1 text-xs text-destructive" aria-live="polite">
            {errors.signature}
          </p>
        )}
      </div>
    </div>
  );
}
